




































































import Vue from 'vue';
import { DocumentService } from '@/services/DocumentService';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { BrowserLocale, DateFormat, DocumentInformationModel, DocumentVersionModel, EVENT_BUS } from '@/types';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { EventBus } from '@/classes/EventBus';
import { DocumentVersionService } from '@/services/DocumentVersionService';
import LoadingOverlay from '@/components/shared/LoadingOverlay.vue';

export default Vue.extend({
  name: 'MStoreDocumentInformationTab',
  data() {
    return {
      isLoading: true,
      isLoadingNewVersion: false,
      documentInformationModel: {} as DocumentInformationModel,
      currentPage: 1,
      searchQuery: '',
      itemsPerPage: 7,
      documentVersions: [] as DocumentVersionModel[],
      selectedVersionId: null as number | null
    };
  },
  methods: {
    getInformationKeys(obj: any) {
      if (!obj) {
        return [];
      }
      return Object.keys(obj);
    },
    async onVersionSelect(this: any, versionDocumentId: number) {
      const versionCabinetId = this.getVersionCabinetId(versionDocumentId);
      if (!versionCabinetId) {
        return;
      }
      await this.onVersionChange(versionCabinetId, versionDocumentId);
    },
    async onVersionChange(this: any, versionCabinetId: string, versionDocumentId: number) {
      if (!versionDocumentId) {
        return;
      }
      try {
        this.isLoadingNewVersion = true;
        await this.getDocumentInformation(versionCabinetId, versionDocumentId);
      } finally {
        this.isLoadingNewVersion = false;
      }
    },
    async getDocumentInformation(this: any, cabinetId: string, documentId: number) {
      this.documentInformationModel = await DocumentService.getDocumentInformationAsync(cabinetId, documentId).catch((reason: any) => {
        return {
          notification: reason.response.data,
          hasNotification: true
        } as DocumentInformationModel;
      });
    },
    getVersionCabinetId(this: any, documentId: number): string | null {
      const version = this.documentVersions.find((v: any) => v.documentId === documentId);
      return version ? version.cabinet.id : null;
    },
    getReferenceValue(value: string) {
      if (!value.isUkShortDateFormat()) {
        return value;
      }
      const format = window.navigator.language.toLowerCase() === BrowserLocale.US ? DateFormat.US : DateFormat.UK;
      const date = moment(value, DateFormat.UK).format(format);
      return moment(date, format, true).isValid() ? date : value;
    },
    async getDocumentVersions(this: any) {
      this.documentVersions = await DocumentVersionService.getDocumentVersionsAsync(this.documentSearchModel.cabinetId, this.documentSearchModel.documentId);
    },
    setDefaultSelectedVersion(this: any) {
      if (this.documentVersions.length > 0) {
        const currentVersion = this.documentVersions.find((v: any) => v.documentId === this.documentSearchModel.documentId);
        this.selectedVersionId = currentVersion ? currentVersion.documentId : this.documentVersions[0].documentId;
      }
    },
    formatVersionText(version: DocumentVersionModel): string {
      const versionNumber = version.number || 'Unknown';
      if (!version.date) {
        return 'Current';
      }
      return `Version ${versionNumber}`;
    },
    async getDocumentInformationTabData(this: any) {
      try {
        this.isLoading = true;
        await this.getDocumentVersions();
        await this.setDefaultSelectedVersion();
        await this.getDocumentInformation(this.documentSearchModel.cabinetId, this.documentSearchModel.documentId);
        await this.$nextTick();
      } finally {
        this.isLoading = false;
      }
    }
  },
  computed: {
    ...mapGetters('documentViewStore', ['documentSearchModel']),
    versionSelectOptions(this: any) {
      return this.documentVersions.map((version: any) => ({
        text: this.formatVersionText(version),
        value: version.documentId
      }));
    },
    isCurrentVersionSelected(this: any) {
      if (!this.documentVersions.length || !this.selectedVersionId) {
        return true;
      }
      const currentVersion = this.documentVersions.find((v: any) => !v.date);
      return currentVersion ? this.selectedVersionId === currentVersion.documentId : this.selectedVersionId === this.documentSearchModel.documentId;
    }
  },
  mounted(this: any) {
    this.getDocumentInformationTabData();
    EventBus.$on(EVENT_BUS.DOCUMENT_VERSION_CHANGED, ({ cabinetId, documentId }: { cabinetId: string; documentId: number }) => {
      this.getDocumentInformation(cabinetId, documentId);
      this.selectedVersionId = documentId;
      this.onVersionChange(cabinetId, documentId);
    });
  },
  beforeDestroy() {
    EventBus.$off(EVENT_BUS.DOCUMENT_VERSION_CHANGED);
  },
  components: {
    LoadingSpinner,
    MStoreTable: () => import('@/components/shared/Table/MStoreTable.vue'),
    MStoreFormSelect: () => import('@/components/shared/MStoreFormSelect.vue'),
    LoadingOverlay
  }
});
